package com.example.mystybag.pdf.model

import com.example.mystybag.pdfUtils.expected.PdfFile

data class PdfFileUIState(
    var file        : PdfFile,
    var withSave    : Boolean = true
)